"use client"

import Image from "next/image"
import { Divider } from "@heroui/divider"

import howtosearch from "@/assets/howtosearch.png"
import howtosearchmobile from "@/assets/howtosearchmobile.png"

export default function PageClient() {
  const handleClick = () => {
    window.open("https://snaptheprice.com/", "_blank")
  }
  return (
    <div className="flex-col items-center px-3 pt-4 text-[#1D2129] sm:px-[120px] sm:pt-10">
      <div className="mb-3 text-[24px] font-bold sm:text-[36px]">
        How to Search Products on SnapThePrice
      </div>
      <div className="mb-6 sm:mb-[40px]">
        SnapThePrice makes it easy to find the lowest prices online—not just
        with the extension, but also directly from the website. If you don’t see
        SnapThePrice in your browser toolbar or you’re shopping on your mobile
        phone, you can use the search box on SnapThePrice.com to snap the best
        deals. Here’s how:
      </div>
      <div className="opacity-100">
        <Divider />
      </div>
      <div className="mb-1 text-[20px] font-bold sm:mt-[32px] sm:mb-3">
        Step 1: Go to SnapThePrice.com
      </div>
      <ul className="list-disc pl-5 text-[14px] text-[#4E5969]">
        <li className="mb-2">Open your browser on desktop or mobile.</li>
        <li className="mb-2">
          Enter{" "}
          <span onClick={handleClick} className="cursor-pointer underline">
            SnapThePrice.com
          </span>{" "}
          in the address bar and press Enter.
        </li>
        <li className="mb-3 sm:mb-8">
          On the homepage, you’ll see the search box at the top.
        </li>
      </ul>
      <div className="mb-1 text-[20px] font-bold sm:mb-3">
        Step 2: Choose What to Paste Into the Search Box
      </div>
      <div className="mb-1 text-[14px] sm:mb-3">
        You have two simple ways to start a search:
      </div>
      <div className="mb-1 font-bold sm:mb-3"> 1.By Product Name</div>
      <ul className="list-disc pl-5 text-[14px] text-[#4E5969]">
        <li className="mb-2">
          Copy and paste the detailed product name into the search box.
        </li>
        <li className="mb-2">
          The more specific your keywords are, the better your results will be.
        </li>
        <li className="mb-2">
          For example: ✅ “Apple iPhone 15 Pro Max 256GB” or ✅ “Nike Air Zoom
          Pegasus 41 Men’s Running Shoes”
        </li>
        <li className="mb-1 sm:mb-3">
          Adding brand + product name + model/variant ensures the system matches
          the exact item.
        </li>
      </ul>
      <div className="mb-1 font-bold sm:mb-3">2.By Product URL</div>
      <ul className="list-disc pl-5 text-[14px] text-[#4E5969]">
        <li className="mb-2">
          While browsing a product detail page on sites like Amazon, BestBuy,
          Walmart, Nike, Apple, and many others, copy the page’s URL.
        </li>
        <li className="mb-2">
          Paste the entire URL into the SnapThePrice search box.
        </li>
      </ul>
      <div className="hidden sm:block">
        <Image src={howtosearch} alt="howtosearch" width={1200} height={257} />
      </div>
      <div className="sm:hidden">
        <Image
          src={howtosearchmobile}
          alt="howtosearchmobile"
          width={375}
          height={192}
        />
      </div>
      <div className="mb-1 text-[20px] font-bold sm:mb-3">
        Step 3: Click Search
      </div>
      <ul className="list-disc pl-5 text-[14px] text-[#4E5969]">
        <li className="mb-2">
          After pasting either the product name or URL, click the “Search”
          button.
        </li>
        <li className="mb-3 sm:mb-8">
          SnapThePrice will instantly scan multiple e-commerce platforms and
          brand websites to locate the same item.
        </li>
      </ul>
      <div className="mb-1 text-[20px] font-bold sm:mb-3">
        Step 4: View the Lowest Price Offers
      </div>
      <ul className="list-disc pl-5 text-[14px] text-[#4E5969]">
        <li className="mb-2">
          Results will appear in seconds, showing you: The lowest available
          price, Other offers across retailers, Shipping and promotion details
          when available.
        </li>
        <li className="mb-3 sm:mb-8">
          The lowest offer will always appear at the top for your convenience.
        </li>
      </ul>
      <div className="mb-1 text-[20px] font-bold sm:mb-3">
        Tips for Best Results
      </div>
      <ul className="list-disc pl-5 text-[14px] text-[#4E5969]">
        <li className="mb-2">
          Be as specific as possible with product names (brand + model +
          size/variant).
        </li>
        <li className="mb-2">
          Use official product URLs to avoid confusion from generic listings.
        </li>
        <li className="mb-3 sm:mb-8">
          If a product isn’t found immediately, try adjusting your search with
          clearer keywords.
        </li>
      </ul>
      <div className="mb-1 text-[20px] font-bold sm:mb-3">Summary</div>
      <div className="mb-2 text-[14px] sm:mb-6">
        Even if you don’t have the SnapThePrice extension installed—or you’re
        shopping on mobile—you can still compare prices easily through the
        SnapThePrice.com search box. Just paste a product name or URL, click
        search, and SnapThePrice will instantly show you the lowest price
        available online.
      </div>
      <div className="mb-2 text-[14px] sm:mb-6">
        👉 Try it today and make sure you never overpay for your favorite
        products!
      </div>
    </div>
  )
}
